/* Scramble Text hero - Originkit port.
   Product names in their product colors, glitch chars in mixed palette
   colors, and the final Maktar settles on a RANDOM palette color
   (different every load). Homepage only. */
(function () {
  'use strict';
  var mark = null;
  var PALETTE = [
    { color: '#6FCF97', flicker: '#3E8A63' },  // Qubii Duo green
    { color: '#FF9F5A', flicker: '#C46A2E' },  // Qubii Power orange
    { color: '#C0C8D4', flicker: '#7A8494' },  // Nukii silver
    { color: '#B79CE4', flicker: '#7D63A8' },  // Piconizer lavender
    { color: '#6EC1E4', flicker: '#3E82A0' },  // Spectra blue
    { color: '#E8A817', flicker: '#C48E0E' }   // Maktar gold
  ];
  var FINAL = { color: '#E8A817', flicker: '#C48E0E' }; // Maktar always CIS gold
  var WORDS = [
    { text: 'Qubii Duo',   phase: 'product', color: '#6FCF97', flicker: '#3E8A63' },
    { text: 'Qubii Power', phase: 'product', color: '#FF9F5A', flicker: '#C46A2E' },
    { text: 'Nukii',       phase: 'product', color: '#C0C8D4', flicker: '#7A8494' },
    { text: 'Piconizer',   phase: 'product', color: '#B79CE4', flicker: '#7D63A8' },
    { text: 'Spectra X2',  phase: 'product', color: '#6EC1E4', flicker: '#3E82A0' },
    { text: 'Maktar',      phase: 'maktar',  color: FINAL.color, flicker: FINAL.flicker }
  ];
  var TIMING = { revealMs: 600, holdMs: 1200, glitchEveryMs: 22, flickerIntensity: 84, flickerSpeed: 10 };
  var HOVER = { radius: 2, pool: 'abcdefghijklmnopqrstuvwxyz' };
  var UP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var LO = 'abcdefghijklmnopqrstuvwxyz';
  function rand(s) { return s[Math.floor(Math.random() * s.length)]; }
  function randColor() { return PALETTE[Math.floor(Math.random() * PALETTE.length)].color; }
  function poolFor(c) { return c && c === c.toLowerCase() && c !== c.toUpperCase() ? LO : UP; }
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var runToken = 0, settled = false, flickerTimers = [];

  var pre = document.createElement('link'); pre.rel = 'preconnect'; pre.href = 'https://fonts.gstatic.com'; pre.crossOrigin = '';
  var lnk = document.createElement('link'); lnk.rel = 'stylesheet';
  lnk.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap';
  document.head.appendChild(pre); document.head.appendChild(lnk);

  function phaseStyle(word) {
    if (word.phase === 'product') {
      mark.style.fontFamily = "'Inter','Hanken Grotesk',system-ui,sans-serif";
      mark.style.fontWeight = '700';
      mark.style.fontSize = 'clamp(48px,9vw,140px)';
      mark.style.lineHeight = '1em';
      mark.style.letterSpacing = '0';
      mark.style.color = word.color;
    } else {
      mark.style.fontFamily = '';
      mark.style.fontWeight = '';
      mark.style.fontSize = '';
      mark.style.lineHeight = '';
      mark.style.letterSpacing = '';
      mark.style.color = word.color; // random final color overrides theme gold
    }
  }
  function charSpacing(word) { return word.phase === 'product' ? '0.05em' : ''; }
  function clearFlicker() { flickerTimers.forEach(clearTimeout); flickerTimers = []; }

  function flickerPass(word, untilMs, token) {
    var speed = 10 / TIMING.flickerSpeed;
    Array.prototype.forEach.call(mark.children, function (span) {
      if (Math.random() > TIMING.flickerIntensity / 100) return;
      var max = Math.max(1, Math.round(TIMING.flickerIntensity / 8));
      var n = Math.max(1, Math.round(max / 2) + Math.floor(Math.random() * (max / 2 + 1)));
      var t = Math.random() * 60;
      for (var i = 0; i < n; i++) {
        var on = t + (40 + Math.random() * 80) * speed;
        var off = on + (30 + Math.random() * 60) * speed;
        if (off > untilMs) break;
        (function (on2, off2) {
          flickerTimers.push(setTimeout(function () { if (token === runToken) span.style.color = word.flicker; }, on2));
          flickerTimers.push(setTimeout(function () { if (token === runToken) span.style.color = word.color; }, off2));
        })(on, off);
        t = off;
      }
    });
  }

  function morphTo(word, token) {
    return new Promise(function (resolve) {
      phaseStyle(word);
      var sp = charSpacing(word);
      var target = word.text;
      var n = Math.max(mark.children.length, target.length);
      while (mark.children.length < n) {
        var s = document.createElement('span');
        s.style.display = 'inline-block';
        s.style.whiteSpace = 'pre';
        s.textContent = rand(UP);
        mark.appendChild(s);
      }
      var spans = Array.prototype.slice.call(mark.children);
      spans.forEach(function (s2) { s2.style.color = randColor(); s2.style.letterSpacing = sp; });
      var start = performance.now();
      var lastGlitch = 0;
      function tick(now) {
        if (token !== runToken) return resolve();
        var p = Math.min(1, (now - start) / TIMING.revealMs);
        var frontier = p * n;
        var doGlitch = now - lastGlitch >= TIMING.glitchEveryMs;
        if (doGlitch) lastGlitch = now;
        for (var i = 0; i < n; i++) {
          var s2 = spans[i];
          if (i < frontier) {
            if (i < target.length) {
              if (s2.textContent !== target[i]) s2.textContent = target[i];
              s2.style.color = word.color;
              s2.style.display = 'inline-block';
            } else {
              s2.style.display = 'none';
            }
          } else if (doGlitch) {
            s2.style.display = 'inline-block';
            s2.textContent = rand(poolFor(target[i]));
            s2.style.color = randColor(); // mixed palette glitch
          }
        }
        if (p < 1) requestAnimationFrame(tick);
        else {
          while (mark.children.length > target.length) mark.removeChild(mark.lastChild);
          resolve();
        }
      }
      requestAnimationFrame(tick);
    });
  }

  function showFinal() {
    var last = WORDS[WORDS.length - 1];
    phaseStyle(last);
    mark.innerHTML = '';
    for (var i = 0; i < last.text.length; i++) {
      var s = document.createElement('span');
      s.style.display = 'inline-block';
      s.style.whiteSpace = 'pre';
      s.style.color = last.color;
      s.textContent = last.text[i];
      mark.appendChild(s);
    }
    settled = true;
  }

  function play() {
    var token = ++runToken;
    settled = false;
    clearFlicker();
    mark.innerHTML = '';
    var idx = 0;
    function next() {
      if (token !== runToken) return;
      if (idx >= WORDS.length) { settled = true; return; }
      var w = WORDS[idx++];
      morphTo(w, token).then(function () {
        if (token !== runToken) return;
        var isLast = idx >= WORDS.length;
        flickerPass(w, isLast ? 1600 : TIMING.holdMs, token);
        if (isLast) { settled = true; return; }
        setTimeout(next, TIMING.holdMs);
      });
    }
    next();
  }

  var hovered = [], lastPivot = -1;
  var MAKTAR = WORDS[WORDS.length - 1];
  function restoreHover() {
    hovered.forEach(function (i) {
      var s = mark.children[i];
      if (s) { s.textContent = MAKTAR.text[i]; s.style.color = MAKTAR.color; }
    });
    hovered = []; lastPivot = -1;
  }
  function onMove(e) {
    if (!settled) return;
    var spans = Array.prototype.slice.call(mark.children);
    var pivot = 0, min = Infinity;
    spans.forEach(function (s, i2) {
      var r = s.getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - e.clientX);
      if (d < min) { min = d; pivot = i2; }
    });
    if (pivot === lastPivot) return;
    restoreHover();
    lastPivot = pivot;
    for (var i = Math.max(0, pivot - HOVER.radius); i <= Math.min(spans.length - 1, pivot + HOVER.radius); i++) {
      spans[i].textContent = rand(HOVER.pool);
      spans[i].style.color = randColor(); // mixed hover glitch
      hovered.push(i);
    }
  }

  function boot() {
    if (!/^\/([a-z]{2}(-[a-z]{2})?\/?)?$/i.test(location.pathname)) return; // homepage only
    mark = document.querySelector('.hero .hero__mark');
    if (!mark) return;
    if (reduced) { showFinal(); return; }
    mark.addEventListener('mousemove', onMove);
    mark.addEventListener('mouseleave', restoreHover);
    play();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
